import profiles from '../../config/profiles';
/* const profiles = {
  basePath: 'http://172.16.80.33:10170'
} */

profiles.newsPath = profiles.basePath
const API = {
  // ----------------现货------------------
  // 获取现货报价
  getSpotPrice: profiles.basePath + '/rest/enweb/spot/getSpotPrice',
  // 获取现货价格走势图数据
  getChartPrices: profiles.basePath + '/rest/enweb/spot/getChartPrices',
  // ----------------SHMETX------------------
  // shme指数行情
  getQuotation: profiles.basePath + '/rest/shmetx/getQuotation',
  // shme指数说明
  getInstruction: profiles.basePath + '/rest/shmetx/getInstruction',
  // shme指数走势图
  getChart: profiles.basePath + '/rest/shmetx/getChart',
  // 利率汇率
  getShmetxIndex: profiles.basePath + '/rest/shmetx/getIndexQuotations',
  // 主力合约行情
  getShmetxMain: profiles.basePath + '/rest/shmetx/getMainQuotations',
  // 交易日历
  getTradingCalendar: profiles.basePath + '/rest/shmetx/getTradingCalendar',
  // 首页公告
  getNoticeContent: profiles.basePath + '/rest/enweb/notice/getValidNotice',

  // about us
  // 获取价格说明一级
  getPriceInstructNav: profiles.basePath + '/rest/enweb/spot/querySpotColumn',
  // 获取价格说明二级
  getPriceInstructItem: profiles.basePath + '/rest/enweb/spot/querySpotInstruction',
  // ---------------News---------------
  // 一级栏目列表
  getNewsColList: profiles.newsPath + '/rest/news/web/getNewsColList',
  // 首页banner
  getBanner: profiles.newsPath + '/rest/enweb/notice/getBanner',
  // 首页资讯列表
  getHomeNewsList: profiles.newsPath + '/rest/news/web/getHomeNewsList',
  // 首页vip资讯列表
  getVipNews: profiles.newsPath + '/rest/news/web/getVipNews',
  // 新闻第四个
  getVipNewsFourth: profiles.newsPath + '/rest/news/getMetalkMore',
  // 首页Daily列表
  getDaily: profiles.newsPath + '/rest/news/web/getDaily',
  // 二级栏目资讯列表
  getNewsList: profiles.newsPath + '/rest/news/web/getNewsList',
  // 获取快讯
  getNewsFlashList: profiles.newsPath + '/rest/news/getNewsFlashList',
  // 获取新闻详情
  getNewsDetail: profiles.newsPath + '/rest/news/web/getNewsDetail',
  // 获取首页热门新闻
  getHomeNewsTop: profiles.newsPath + '/rest/news/web/getHomeNewsTop',
  // 获取热门新闻
  getHotNews: profiles.newsPath + '/rest/news/web/getHotNews',
  // 根据一级栏目id获取二级栏目列表
  getNode2ColList: profiles.newsPath + '/rest/news/web/getNode2ColList',
  // 二级栏目置顶资讯列表
  getNode2NewsTop: profiles.newsPath + '/rest/news/web/getNode2NewsTop',
  // 根据标签搜索资讯
  searchNewsByTagName: profiles.newsPath + '/rest/news/web/searchNewsByTagName',
  // 查询web二级栏目资讯列表更多
  getNode2NewsMoreList: profiles.newsPath + '/rest/news/web/getNode2NewsMoreList',
  /* 数据中心 */
  // 一级菜单
  getfirstColumn: profiles.newsPath + '/rest/enweb/datacenter/getfirstColumn',
  // 二三级目录
  getChildColumn: profiles.newsPath + '/rest/enweb/datacenter/getChildColumn',
  // table数据及走势图
  getHistoryPrices: profiles.newsPath + '/rest/enweb/datacenter/getHistoryPrices',

  // 获取系统时间接口
  getSystemTime: profiles.newsPath + '/rest/news/web/getSystemTime',
  // ----------------newsFlash-------------
  // 获取快讯标签
  getWebEnNewsFlashTag: profiles.newsPath + '/rest/news/web/getWebEnNewsFlashTag',
  // 获取快讯内容
  getWebEnNewsFlashList: profiles.newsPath + '/rest/news/web/getWebEnNewsFlashList',
  // ----------------User------------------
  // 获取验证码
  getEmailCode: profiles.ssoPath + '/emailcode/regist',
  // 判断email是否存在
  getCheckRegistEmail: profiles.ssoPath + '/checkregistEmail',
  // 验证码是否有效
  getEmailCodeValid: profiles.ssoPath + '/emailcode/valid',
  // 注册事件
  submitRegister: profiles.ssoPath + '/enregist',
  // 获取个人信息
  getAccount: profiles.basePath + '/secure/rest/account',
  // 登录
  loginSubmit: profiles.ssoPath + '/enlogin',
  // 登出
  loginOut: profiles.basePath + '/secure/rest/logout',
  // 重置密码
  resetPassWord: profiles.ssoPath + '/enresetpwd',
  // 更换邮箱
  changeEmail: profiles.basePath + '/secure/rest/user/sendEmail',
  // 修改邮箱
  updateEmail: profiles.basePath + '/secure/rest/user/updateEmail',
  // 修改密码
  updatePwd: profiles.basePath + '/secure/rest/user/updatepwd',
  // 忘记密码获取验证码
  getEmailCodeReset: profiles.ssoPath + '/emailcode/reset',
  // shfe
  getShfeData: profiles.basePath + '/rest/future/getRateQuotations',
  // 国际区号
  getAreaCode: profiles.basePath + '/rest/getCountryCodeList',
  // 查询是否已申请试阅
  getIsApplyRead: profiles.basePath + '/secure/rest/user/isEnWebApplyRead',
  // 申请试阅
  postApplyRead: profiles.basePath + '/secure/rest/user/enWebApplyRead',
  // 校验新闻权限（查看vip新闻是否有权限）
  checkPower: profiles.basePath + '/rest/web/checkPower'
}
export default API



// WEBPACK FOOTER //
// ./src/utils/api.js